// Regra pura do valor unitário (unit_value) de um item ao montar a NF-e a partir do pedido.
//
// Em NF de bonificação/presente o produto vai a valor CHEIO: a própria natureza de bonificação
// já indica ao fisco que é um presente (imposto não recolhido sobre esse valor), então o
// desconto do item do pedido (tipicamente 100% num item presente) NÃO é aplicado. Nas demais
// notas mantém-se o preço líquido, com o desconto percentual do item.
//
// Extraída para ser testável sem renderizar o formulário (mesmo padrão de paymentPlan.ts).
export function resolveInvoiceUnitValue(
  unitPrice: number,
  discountPercent: number,
  isGiftInvoice: boolean,
): number {
  const base = unitPrice || 0;
  const effective = isGiftInvoice ? base : base * (1 - (discountPercent || 0) / 100);
  // Mantém 4 casas decimais (unit_value da NF-e), evitando ruído de ponto flutuante.
  return Math.round(effective * 10000) / 10000;
}
